/**
 * 방문 분류 (2026-10-26 · 주간 보고 10/19~25 후속 ②) — 사람 방문과 자동·내부 접속을 나눈다. 순수 함수 · 회귀 scripts/qc/visit-class.test.ts.
 *   자동 (auto)     = 검색·SNS 수집 봇 · 헤드리스·자동화 브라우저 (navigator.webdriver · HeadlessChrome · Lighthouse · Playwright 등)
 *   내부 (internal) = 관리자·내부 확인 접속 (관리자로 로그인한 적 있는 브라우저 · ?internal=1 로 표시한 브라우저 · 관리자·테스트 회원 uid 이벤트)
 * 화면 쪽 (analytics.ts) 이 page_view 에 metadata.cl ("auto"|"internal") 을 붙이고, 보고 (daily-report) 가 브라우저 단위로 묶는다.
 * 2026-10-26 이전 이벤트에는 cl 이 없어 uid 로만 내부를 가른다 (자동 접속은 그 전 기록으로는 가를 수 없다).
 */
export type VisitClass = "human" | "auto" | "internal";

/** 알려진 봇·자동화 UA (사람 앱 브라우저 — 카카오톡·네이버·다음 앱 — 은 넣지 않는다). */
export const AUTO_UA_RE =
  /(googlebot|bingbot|yandex(bot)?|baiduspider|duckduckbot|applebot|petalbot|ahrefsbot|semrushbot|mj12bot|dotbot|bytespider|gptbot|claudebot|ccbot|amazonbot|facebookbot|twitterbot|slackbot|discordbot|telegrambot|crawler|spider|slurp|headlesschrome|lighthouse|pagespeed|playwright|puppeteer|phantomjs|selenium|yeti\/|facebookexternalhit|google-inspectiontool|bot\/\d|\+https?:\/\/)/i;

/** 브라우저에서 이 접속의 분류 (사람이면 null). */
export function clientVisitClass(x: { userAgent: string; webdriver: boolean; internalFlag: boolean }): Exclude<VisitClass, "human"> | null {
  if (x.internalFlag) return "internal";
  if (x.webdriver || AUTO_UA_RE.test(x.userAgent)) return "auto";
  return null;
}

/**
 * 브라우저 (analytics sessionId) 별 분류 — 사람이 아닌 것만 돌려준다.
 * 내부가 자동보다 우선 (관리자가 자동화 도구로 본 접속도 내부).
 */
export function classifyBrowsers(events: { sessionId: string; uid?: string | null; cl?: string | null }[], internalUids: ReadonlySet<string>): Map<string, Exclude<VisitClass, "human">> {
  const out = new Map<string, Exclude<VisitClass, "human">>();
  for (const e of events) {
    const internal = e.cl === "internal" || (!!e.uid && internalUids.has(e.uid));
    if (internal) out.set(e.sessionId, "internal");
    else if (e.cl === "auto" && out.get(e.sessionId) !== "internal") out.set(e.sessionId, "auto");
  }
  return out;
}
